var _excluded = ["code", "escapeHTML", "replaceOptions", "stripHTML", "TextComponent", "uppercase", "attributes"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getString, languageChangeEvent } from '../translations';
var reactStringReplace = require('react-string-replace');
var propTypes = {
  code: PropTypes.string.isRequired,
  replaceOptions: PropTypes.object,
  className: PropTypes.string,
  TextComponent: PropTypes.any,
  uppercase: PropTypes.bool,
  escapeHTML: PropTypes.bool,
  stripHTML: PropTypes.bool,
  attributes: PropTypes.object
};
var LocaleString = /*#__PURE__*/function (_Component) {
  function LocaleString() {
    var _this;
    _classCallCheck(this, LocaleString);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LocaleString, [].concat(args));
    _defineProperty(_this, "stripSymbols", function (renderString) {
      var tag = /\$\{/g;
      var removeCurly = new RegExp('}', 'g');
      var returnString = renderString;
      returnString = returnString.replace(removeCurly, '');
      returnString = returnString.replace(tag, '');
      return returnString;
    });
    _defineProperty(_this, "replaceWithReactComponent", function (templateString, o) {
      function replaceKeys(match, key) {
        var component = o[key];
        var componentString = reactStringReplace(templateString, "$<".concat(key, ">"), function () {
          return component;
        });
        return componentString;
      }
      var strings = Object.keys(o).map(function (key) {
        return replaceKeys(templateString, key);
      }).flat();
      return strings;
    });
    _defineProperty(_this, "onLanguageChange", function () {
      return _this.forceUpdate();
    });
    return _this;
  }
  _inherits(LocaleString, _Component);
  return _createClass(LocaleString, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      languageChangeEvent.on(this.onLanguageChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      languageChangeEvent.off(this.onLanguageChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        code = _this$props.code,
        _this$props$escapeHTM = _this$props.escapeHTML,
        escapeHTML = _this$props$escapeHTM === void 0 ? false : _this$props$escapeHTM,
        replaceOptions = _this$props.replaceOptions,
        _this$props$stripHTML = _this$props.stripHTML,
        stripHTML = _this$props$stripHTML === void 0 ? false : _this$props$stripHTML,
        _this$props$TextCompo = _this$props.TextComponent,
        TextComponent = _this$props$TextCompo === void 0 ? 'span' : _this$props$TextCompo,
        _this$props$uppercase = _this$props.uppercase,
        uppercase = _this$props$uppercase === void 0 ? false : _this$props$uppercase,
        attributes = _this$props.attributes,
        props = _objectWithoutProperties(_this$props, _excluded);

      //seperate out the regular replacements with the jsx replacements
      var stringReplaceOptions = {};
      var jsxReplaceOptions = {};
      for (var property in replaceOptions) {
        if (typeof replaceOptions[property] === 'string' || typeof replaceOptions[property] === 'number') {
          stringReplaceOptions[property] = '' + replaceOptions[property];
        } else if ( /*#__PURE__*/React.isValidElement(replaceOptions[property])) {
          jsxReplaceOptions[property] = replaceOptions[property];
        }
      }
      var translatedString = '';

      //do all the easy string replacements
      translatedString = getString(code, stringReplaceOptions, attributes);

      //do all the jsx replacements
      var translatedStrings = [];
      if (Object.keys(jsxReplaceOptions).length) {
        translatedStrings = this.replaceWithReactComponent(translatedString, jsxReplaceOptions);
      } else {
        translatedStrings = [translatedString];
      }

      //and the rest
      var content = stripHTML ? translatedString.replace(/<(?:.|\n)*?>/gm, '') : translatedStrings;
      if (uppercase) {
        if (Array.isArray(content)) {
          content = content.map(function (item) {
            return item.toUpperCase();
          });
        } else {
          content = content.toUpperCase();
        }
      }

      //give back the string
      return escapeHTML || Object.keys(jsxReplaceOptions).length ? /*#__PURE__*/React.createElement(TextComponent, _extends({
        "data-sl-anchor": code,
        "data-key": code,
        style: {
          'pointerEvents': 'none'
        }
      }, props), content) : /*#__PURE__*/React.createElement(TextComponent, _extends({
        "data-sl-anchor": code,
        "data-key": code,
        dangerouslySetInnerHTML: {
          __html: content
        },
        style: {
          'pointerEvents': 'none'
        }
      }, props));
    }
  }]);
}(Component);
LocaleString.propTypes = propTypes;
export default LocaleString;
//# sourceMappingURL=locale-string.js.map